var E;!function(E){E[E.N=0]="N",E[E.NE=1]="NE",E[E.E=2]="E",E[E.SE=3]="SE",E[E.S=4]="S",E[E.SW=5]="SW",E[E.W=6]="W",E[E.NW=7]="NW"}(E||(E={}));export{E as HexGridTreeNodeDirection};
